import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.8} clipPath="url(#a)">
      <path
        opacity={0.8}
        d="M7.114 6.194a1.289 1.289 0 0 0-1.202-.86h-2.62C2.578 5.333 2 5.92 2 6.647v14.704c0 .727.578 1.315 1.292 1.315H5.94a1.29 1.29 0 0 0 1.203-.857 2.427 2.427 0 0 1 2.268-1.595c1.037 0 1.923.663 2.269 1.595.19.513.665.857 1.202.857h2.493c.714 0 1.292-.588 1.292-1.315V6.65c0-.727-.578-1.315-1.292-1.315h-2.512c-.54 0-1.014.346-1.202.86a2.431 2.431 0 0 1-2.274 1.606 2.426 2.426 0 0 1-2.273-1.607Z"
        fill="url(#b)"
      />
      <g filter="url(#c)">
        <path
          d="M11.781 2.194a1.289 1.289 0 0 0-1.203-.86h-2.62c-.714 0-1.291.587-1.291 1.314v14.704c0 .727.577 1.315 1.292 1.315h2.648a1.29 1.29 0 0 0 1.203-.857 2.427 2.427 0 0 1 2.268-1.595c1.037 0 1.923.663 2.268 1.595.19.513.665.857 1.203.857h2.492c.715 0 1.292-.588 1.292-1.315V2.65c0-.727-.577-1.315-1.291-1.315H17.53c-.54 0-1.015.346-1.203.86a2.431 2.431 0 0 1-2.274 1.606 2.426 2.426 0 0 1-2.272-1.607Z"
          fill="url(#d)"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#e)">
        <path
          d="M9 12.5h1.508l1.006-1.608h.053l.988 1.608h1.517l-1.632-2.395 1.543-2.274h-1.481l-.927 1.522h-.052l-.927-1.522H9.097l1.552 2.283L9 12.5Z"
          fill="url(#f)"
        />
        <path
          d="M19 10.157h-.67V6.5h-1.49l-2.462 3.493v1.227h2.726v1.28h1.226v-1.28H19v-1.063Zm-3.537 0v-.052l1.588-2.308h.053v2.36h-1.64Z"
          fill="url(#g)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={2}
        y1={14}
        x2={16.848}
        y2={11.85}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8E5E9" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.56} />
      </linearGradient>
      <linearGradient
        id="d"
        x1={6.667}
        y1={10}
        x2={21.515}
        y2={7.85}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#CFE7FD" stopOpacity={0.78} />
      </linearGradient>
      <linearGradient
        id="f"
        x1={9}
        y1={6.5}
        x2={19.076}
        y2={6.63}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B2FF" />
        <stop offset={1} stopColor="#0047FF" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={9}
        y1={6.5}
        x2={19.076}
        y2={6.63}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B2FF" />
        <stop offset={1} stopColor="#0047FF" />
      </linearGradient>
      <filter
        id="c"
        x={2.667}
        y={1.333}
        width={22.667}
        height={25.333}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.197999 0 0 0 0 0.478402 0 0 0 0 0.816667 0 0 0 0.23 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2332_38361"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2332_38361"
          result="shape"
        />
      </filter>
      <filter
        id="e"
        x={7}
        y={5.5}
        width={14}
        height={10}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.00392157 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 0.37 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2332_38361"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2332_38361"
          result="shape"
        />
      </filter>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
